/**
 * LabelChip — the "group: value" chips on cards + detail modal.
 * Card variant: height 22, pad 0 9, radius r2, paper-2 bg, line border.
 * Detail variant: height 26, pad 0 10.
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { colors, fontFamily, fontSize, fontWeight, radii } from '../theme';

type Props = { group: string; value: string; size?: 22 | 26; valueColor?: string };

export default function LabelChip({ group, value, size = 22, valueColor = colors.ink2 }: Props) {
  return (
    <View style={[styles.chip, { height: size }]}>
      <Text style={styles.group}>{group}</Text>
      <Text style={[styles.value, { color: valueColor } as any]}>{value}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 9,
    borderRadius: radii.r2,
    backgroundColor: colors.paper2,
    borderWidth: 1,
    borderColor: colors.line,
  },
  group: { fontFamily: fontFamily.sans, fontSize: fontSize.xs, color: colors.ink4, fontWeight: fontWeight.medium },
  value: { fontFamily: fontFamily.sans, fontSize: fontSize.xs, fontWeight: fontWeight.medium },
});
